export const paymentCardStatuses = {
  pendingActivation: 'PendingActivation',
  active: 'Active',
  pendingDeactivation: 'PendingDeactivation',
  inactive: 'Inactive',
};

const statusesByNumber = {
  1: paymentCardStatuses.pendingActivation,
  2: paymentCardStatuses.active,
  3: paymentCardStatuses.pendingDeactivation,
  4: paymentCardStatuses.inactive,
};

const statusesByText = {
  pendingactivation: paymentCardStatuses.pendingActivation,
  active: paymentCardStatuses.active,
  pendingdeactivation: paymentCardStatuses.pendingDeactivation,
  inactive: paymentCardStatuses.inactive,
};

const normalizeStatus = status => {
  if (status === null || status === undefined) return null;
  if (typeof status === 'number') return statusesByNumber[status] || null;

  const trimmed = `${status}`.trim();
  if (statusesByNumber[trimmed]) return statusesByNumber[trimmed];

  return statusesByText[trimmed.replace(/\s/g, '').toLowerCase()] || null;
};

export class PaymentCardModel {
  constructor({ hasCard, status, mask, issuer, expirationDate, activatedAt, deactivationPending } = {}) {
    this.hasCard = Boolean(hasCard);
    this.status = normalizeStatus(status);
    this.mask = mask || null;
    this.issuer = issuer || null;
    this.expirationDate = expirationDate || null;
    this.activatedAt = activatedAt || null;
    this.deactivationPending = Boolean(deactivationPending) || this.status === paymentCardStatuses.pendingDeactivation;
    this.pendingActivation = this.status === paymentCardStatuses.pendingActivation;
    this.active = this.status === paymentCardStatuses.active;
    this.pendingDeactivation = this.deactivationPending;
  }
}
